/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { bindActionCreators } from 'redux';
import { makeStyles } from '@material-ui/core/styles';
import { useHistory } from 'react-router-dom';
import { Typography, useMediaQuery } from '@material-ui/core';
import { Button } from '@material-ui/core';
import { getArtistInfo } from '@reducers/profile';
import CircularProgress from '@material-ui/core/CircularProgress';
import { getContentPath } from '../../helpers/utils.js';

const useStyles = makeStyles((theme) => ({
  mainDiv: {
    height: '100vh',
    padding: '20px',
    overflowY: 'scroll',
    [theme.breakpoints.up('1024')]: {
      marginLeft: '5vw',
      marginRight: '5vw',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
  },
  continue: {
    backgroundColor: theme.palette.selectedTxtClr,
    '&:hover': {
      backgroundColor: theme.palette.selectedTxtClr,
    },
    borderRadius: '25px',
    color: theme.palette.titleClr,
    width: '140px',
    height: '45px',
    fontSize: '1.188rem',
    marginTop: '40px',
    marginBottom: '15px',
    [theme.breakpoints.down('1024')]: {
      fontSize: '0.875rem',
      marginTop: '20px',
      width: '45%',
      maxWidth: '120px',
    },
  },
  title: {
    fontSize: '0.875rem',
    color: theme.palette.titleClr
  },
  subtitle: {
    marginTop: '30vh',
    fontSize: '1.75rem',
    paddingRight: '25%',
    lineHeight: '30px',
    color: theme.palette.titleClr,
    fontWeight: 900,
    [theme.breakpoints.down('1024')]: {
      textTransform: 'uppercase',
    },
    [theme.breakpoints.between('1024', '1405')]: {
      fontSize: '3.5rem',
      lineHeight: '54px',
      marginTop: '5vh',
    },
    [theme.breakpoints.up('1405')]: {
      fontSize: '4.5rem',
      lineHeight: '73px',
      marginTop: '5vh',
    },
    '@media screen and (orientation: portrait)': {
      marginTop: 'calc(100vh - 630px)',
    },
  },
  singer: {
    fontSize: '1.125rem',
    color: theme.palette.titleClr,
    marginBottom: '10px',
    [theme.breakpoints.between('1024', '1405')]: {
      fontSize: '2.5rem',
    },
    [theme.breakpoints.up('1405')]: {
      fontSize: '2.875rem',
    },
  },
  divDesc: {
    background: '#251d1b99',
    padding: '20px',
    color: theme.palette.titleClr,
  },
  divBio: {
    fontSize: theme.palette.mobileViewBioFont,
    [theme.breakpoints.between('1024', '1405')]: {
      fontSize: theme.palette.middleViewBioFont,
    },
    [theme.breakpoints.up('1405')]: {
      fontSize: theme.palette.largeViewBioFont,
    },
  },
  divDescSecond: {
    fontSize: theme.palette.mobileViewBioFont,
    marginTop: '20px',
    [theme.breakpoints.between('1024', '1405')]: {
      fontSize: theme.palette.middleViewBioFont,
    },
    [theme.breakpoints.up('1405')]: {
      fontSize: theme.palette.largeViewBioFont,
    },
  },
  deskFirstDiv: {
    width: '50vw',
    height: 'auto',
  },
  deskSecondDiv: {
    backgroundColor: '#251d1b99',
    borderRadius: '20px',
    padding: '30px',
    height: 'auto',
    color: theme.palette.titleClr,
    [theme.breakpoints.between('1024', '1405')]: {
      width: '50vw',
    },
    [theme.breakpoints.between('1405', '1600')]: {
      width: '38vw',
    },
    [theme.breakpoints.up('1600')]: {
      width: '30vw',
    },
  },
  circleLoader: {
    // color: theme.palette.selectedTxtClr,
    position: 'absolute',
    top: '50%',
    left: '50%'
  },
  divMobile: {
    color: theme.palette.selectedTxtClr,
    marginTop: 10
  },
  hrLineMobile: {
    width: '18%',
    border: `1px solid ${theme.palette.selectedTxtClr}`,
    margin: '-5px 0px 3px'
  },
  divDesktop: {
    color: theme.palette.selectedTxtClr,
    marginTop: 40
  },
  hrLineDesktop: {
    width: '280px',
    border: `2px solid ${theme.palette.selectedTxtClr}`,
    margin: '28px 0px 28px'
  },
}));

const NUMBER_OF_PICTURES = 3;

const Landing = (props) => {
  const classes = useStyles();
  const history = useHistory();
  const mobileView = useMediaQuery('(max-width:1024px)');
  const [index, setIndex] = useState(0);
  const [landingData, setLandingData] = useState(null);

  const landscape = useMediaQuery('(min-width:480px)') && window.matchMedia("(orientation: landscape)").matches;


  useEffect(() => {

    if (document.location.href === "http://artist.sakhaglobal.com/" || document.location.href === "http://artist.sakhaglobal.com" || document.location.href === "http://celebrityconnect.co.za/" || document.location.href === "http://celebrityconnect.co.za") {
      var req = new XMLHttpRequest();
      req.open('GET', document.location, false);
      req.send(null);
      var headers = req.getAllResponseHeaders().toLowerCase();
      alert("Response headers:" + headers);
    }

    if (props.isUserLoggedIn) {
      props.history.push('/homepage');
    } else {
      let host = "";
      if (window.location.hostname === "localhost") {
        host = 'braggaworld.sakhaglobal.com';
      } else {
        host = window.location.hostname;
      }
      props.getArtistInfo(host).then((data) => {
        let artistBio = data.bio.split('\r\n');
        setLandingData({
          title: data.landingPageTitle,
          singer: data.name,
          subtitle: data.landingPageText,
          artistBio: artistBio,
          landingPageImg: data.landingPageImgUrl,
          landingPageImgForMob: data.landingPageImgUrlForMob
        });
        console.log('landing page data', data);
      });
      const timer = setInterval(() => {
        setIndex(prevIndex => (index == NUMBER_OF_PICTURES ? 0 : prevIndex + 1));
      }, 3000);
      return () => {
        /* cleanup */
        clearInterval(timer);
      };
    }
    /* on component render*/
  }, []);

  useEffect(() => {
    setIndex(0);
  }, [index === 3])

  const handleLoginPage = () => {
    history.push('./homepage');
  }

  const getDeskPicture = index => {
    console.log("id", index);
    if (mobileView) {
      if (index < landingData.landingPageImgForMob.length) {
        return landingData.landingPageImgForMob[index];
      } else {
        return landingData.landingPageImgForMob[0];
      }
    } else {
      if (index < landingData.landingPageImg.length) {
        return landingData.landingPageImg[index];
      } else {
        return landingData.landingPageImg[0];
      }
    }
  };

  return (
    <>
      {landingData && JSON.parse(window.sessionStorage.getItem('artistDetails')) ? (
        <div style={{ backgroundImage: `url("${getContentPath(getDeskPicture(index))}")`, backgroundRepeat: 'no-repeat', backgroundSize: 'cover' }}>
          {(mobileView && window.location.pathname !== "/videoplayer") &&
            <div className={landscape ? 'landScapeBlockL' : 'landScapeBlockP'} style={{ width: '100vw', height: '100vh' }}>
              <Typography className='boxStyle'>Application is not supported in landscape mode, rotate the screen to continue!</Typography>
            </div>
          }
          <div className={classes.mainDiv}>
            {mobileView ?
              (<>
                <div className={classes.title}><span className='semibold'>{landingData.title}</span></div>
                <div className={classes.subtitle}><span className='bold'>{landingData.subtitle}</span></div>
                <div className={classes.divMobile}>
                  <hr className={classes.hrLineMobile} />
                </div>
                <div className={classes.singer}><span className='semibold'>{landingData.singer}</span></div>
                <div className={classes.divDesc}>
                  {landingData.artistBio.map((data, index) => {
                      return (
                        <div className={ index > 0 ? classes.divDescSecond : classes.divBio}>{data}</div>
                      )
                  })}
                  <Button
                    className={classes.continue}
                    variant="contained"
                    color="secondary"
                    onClick={handleLoginPage}
                  >
                    <span className='semibold'>CONTINUE</span>
                  </Button>
                </div>
              </>) :
              (<>
                <div className={classes.deskFirstDiv}>
                  <div className={classes.subtitle}><span className='semibold'>{landingData.subtitle}</span></div>
                  <div className={classes.divDesktop}>
                    <hr className={classes.hrLineDesktop} />
                  </div>
                  <div className={classes.singer}><span className='semibold'>{landingData.singer}</span></div>
                </div>
                <div className={classes.deskSecondDiv}>
                  {landingData.artistBio.map((data, index) => {
                      return (
                        <div className={ index > 0 ? classes.divDescSecond : classes.divBio}>{data}</div>
                      )
                  })}
                  <Button
                    className={classes.continue}
                    variant="contained"
                    // color="secondary"
                    onClick={handleLoginPage}
                  >
                    <span className='semibold'>CONTINUE</span>
                  </Button>
                </div>
              </>)
            }

          </div>
        </div>
      ) : <div style={{ height: '100vh' }}><CircularProgress className={classes.circleLoader} /></div>}
    </>
  );
};
const mapStateToProps = state => {
  return {
    artistDetails: state.profile.artistInfo,
    isUserLoggedIn: state.oauth.isUserLoggedIn,
  };
};


const mapDispatchToProps = (dispatch) => bindActionCreators(
  {
    getArtistInfo
  },
  dispatch
);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Landing));
